import {NgModule} from '@angular/core';
import {CardApiService} from './services/card.api.service';
import {CommonModule} from '@angular/common';
import {LayoutModule} from '@layoutComponents/layout.module';
import {ModalModule} from '@components/modal/modal.module';
import {CardFormModalComponent} from './components/card-form-modal/card-form-modal.component';
import {EquipmentSelectModule} from '@components/equipment-select/equipment-select.module';
import {EquipmentCreateOptionsService} from '@services/equipment-create-options.service';
import {ApparatusCardCommonModule} from '@subforms/apparatus-card-common/apparatus-card-common.module';
import {ApparatusCardCalibrationsModule} from '@subforms/apparatus-card-calibrations/apparatus-card-calibrations.module';
import {PipesModule} from '@pipes/pipes.module';
import {ReactiveFormsModule} from '@angular/forms';
import {CardSelectModalComponent} from './components/card-select-modal/card-select-modal.component';
import {PagingControlModule} from '@components/paging-control/paging-control.module';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {FiltersPanelComponent} from './components/filters-panel/filters-panel.component';
import {RouterModule} from '@angular/router';
import {CardSelectModalFiltersPanelComponent} from '@modules/equipment-card/components/card-select-modal-filters-panel/card-select-modal-filters-panel.component';
import { EquipmentTabListItemComponent } from './components/equipment-tab-list-item/equipment-tab-list-item.component';
import {IconsModule} from '@lab365/icons';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        LayoutModule,
        ModalModule,
        EquipmentSelectModule,
        ApparatusCardCommonModule,
        ApparatusCardCalibrationsModule,
        PipesModule,
        FormFieldModule,
        PagingControlModule,
        FormFieldModule,
        ModalModule,
        DirectivesModule,
        IconsModule,
    ],
    exports: [
        CardSelectModalComponent,
        FiltersPanelComponent,
        EquipmentTabListItemComponent,
    ],
    declarations: [
        CardFormModalComponent,
        CardSelectModalComponent,
        FiltersPanelComponent,
        CardSelectModalFiltersPanelComponent,
        EquipmentTabListItemComponent,
    ],
    providers: [
        CardApiService,
        EquipmentCreateOptionsService,
    ],
    entryComponents: [
        CardFormModalComponent,
    ]
})
export class EquipmentCardModule {
}
